// frontend/src/components/reporting/activity/DebriefContent.js
// The two read-only debrief bodies, one per methodology, shared by every
// report view that renders a debrief:
//   - basic: AssessmentPrintDocument (case_study, learning_goal, narrative, debrief)
//   - real:  RoleplayPrintDocument (case_study, golden_transcript, debrief)
//
// Contract: `data.debrief` is the report *body* (analytics_reports.result),
// not a report row. Callers holding a full report must pass `report.result`.
//
// Consumers: ConversationDebriefPage (RPT-003, both branches) and
// CoachCohortReports (basic branch only — the coach's assessment list is
// real_assessment reports).

import PropTypes from 'prop-types';
import AssessmentPrintDocument from '../../assessment/AssessmentPrintDocument';
import RoleplayPrintDocument from '../../roleplay/RoleplayPrintDocument';

export function BasicDebriefContent({ data, conversationTitle }) {
  const adaptedScript = (data.narrative || []).map((pair) => ({
    pairId: String(pair.exchangeNumber),
    me: { content: pair.me },
    them: { content: pair.them },
    me_thought: { content: pair.meThought },
    them_thought: { content: pair.themThought },
  }));

  return (
    <AssessmentPrintDocument
      conversationTitle={conversationTitle}
      caseStudy={data.caseStudy}
      script={adaptedScript}
      learningGoal={data.learningGoal}
      report={data.debrief}
      includeDebrief={!!data.debrief}
      debriefUnavailableMessage="Debrief not available"
    />
  );
}

export function RealDebriefContent({ data, conversationTitle }) {
  const exchanges = (data.goldenTranscript || []).map((msg) => ({
    clientText: msg.speaker === 'user' ? msg.content : null,
    characterText: msg.speaker === 'character' ? msg.content : null,
  }));

  return (
    <RoleplayPrintDocument
      conversationTitle={conversationTitle}
      caseStudy={data.caseStudy}
      exchanges={exchanges}
      debriefReport={data.debrief ? { status: 'completed', result: data.debrief } : null}
      debriefNotReadyMessage="Debrief not available"
    />
  );
}

BasicDebriefContent.propTypes = {
  data: PropTypes.shape({
    caseStudy: PropTypes.object,
    learningGoal: PropTypes.string,
    narrative: PropTypes.array,
    debrief: PropTypes.object,
  }).isRequired,
  conversationTitle: PropTypes.string,
};

RealDebriefContent.propTypes = {
  data: PropTypes.shape({
    caseStudy: PropTypes.object,
    goldenTranscript: PropTypes.array,
    debrief: PropTypes.object,
  }).isRequired,
  conversationTitle: PropTypes.string,
};
